import { studyMissionsConstants } from "@data/constants/studyMissionsConstants"

// Le tuteur écarte une proposition avant l'envoi : on la retire du brouillon
// stocké, pas d'une liste parallèle. Ainsi l'affichage, le compte annoncé avant
// une régénération et ce qui part à l'envoi lisent tous la même chose.
export const removeDraftActivity = ({
    liveOccurrenceId,
    studentId,
    index,
}) => ({
    type: studyMissionsConstants.REMOVE_DRAFT_ACTIVITY,
    liveOccurrenceId,
    studentId,
    index,
})
